export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** `Date` type as integer. Type represents date and time as number of milliseconds from start of UNIX epoch. */
  Timestamp: { input: Date | number; output: number; }
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: any; output: any; }
};

export type AcceptJoinRequestInput = {
  id: Scalars['ID']['input'];
};

export type AddCommunityAdminInput = {
  adminUuid: Scalars['ID']['input'];
  communityUuid: Scalars['ID']['input'];
};

export type AddMembersToTeamInput = {
  membersIds: Array<Scalars['ID']['input']>;
  teamUuid: Scalars['ID']['input'];
};

export type AddTemporaryConnectionInput = {
  careRecipientsMembersId: Array<Scalars['Int']['input']>;
  caregiverEmail: Scalars['String']['input'];
  endDate: Scalars['Timestamp']['input'];
  organisationUuid: Scalars['ID']['input'];
  startDate: Scalars['Timestamp']['input'];
};

export type AppInvitation = {
  __typename?: 'AppInvitation';
  careReceiverToConnect: User;
  connectionEndDate?: Maybe<Scalars['Timestamp']['output']>;
  connectionStartDate?: Maybe<Scalars['Timestamp']['output']>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['Timestamp']['output'];
  from: User;
  id: Scalars['ID']['output'];
  toEmail: Scalars['String']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['Timestamp']['output'];
};

export type AppVersion = {
  __typename?: 'AppVersion';
  androidVersionCode?: Maybe<Scalars['Int']['output']>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['Timestamp']['output'];
  iOSBuildNumber?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  releaseNotes?: Maybe<Scalars['String']['output']>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['Timestamp']['output'];
  version: Scalars['String']['output'];
};

export type AssignCareReceiverMemberToCaregiverMembersInput = {
  careRecipientMemberId: Scalars['ID']['input'];
  caregiverMembersIds: Array<Scalars['ID']['input']>;
  organisationUuid: Scalars['ID']['input'];
};

export type AssignTeamsToMemberInput = {
  memberId: Scalars['ID']['input'];
  teamsUuids: Array<Scalars['ID']['input']>;
};

export type Auth = {
  __typename?: 'Auth';
  /** JWT access token */
  accessToken: Scalars['String']['output'];
  callbackUrl?: Maybe<Scalars['String']['output']>;
  /** JWT media access token */
  mediaToken: Scalars['String']['output'];
  /** JWT refresh token */
  refreshToken: Scalars['String']['output'];
  user: User;
};

export type BasePost = {
  __typename?: 'BasePost';
  selectedUsers?: Maybe<Array<PostAccess>>;
};

export type BasicUser = {
  __typename?: 'BasicUser';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  profilePhoto?: Maybe<File>;
  username: Scalars['String']['output'];
};

export type BlockUser = {
  userId: Scalars['ID']['input'];
};

export type Book = {
  __typename?: 'Book';
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  owner?: Maybe<User>;
  ownerId?: Maybe<Scalars['Int']['output']>;
  pages: Array<Page>;
  title: Scalars['String']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['Timestamp']['output'];
};

export type CareReceiverMemberInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
};

export type CaregiverMemberInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  registerCode?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
};

export type ChangeCareRecipientPasswordInput = {
  newPassword: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type ChangePasswordInput = {
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};

export type ChatMember = {
  __typename?: 'ChatMember';
  id: Scalars['ID']['output'];
  lastReadAt?: Maybe<Scalars['Timestamp']['output']>;
  lastReadMessageId?: Maybe<Scalars['ID']['output']>;
  memberId: Scalars['ID']['output'];
  profile: User;
};

export type ChatMessage = {
  __typename?: 'ChatMessage';
  content: Scalars['String']['output'];
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['Timestamp']['output'];
  from: User;
  id: Scalars['ID']['output'];
  media: Array<File>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['Timestamp']['output'];
};

export type ChatMessageConnection = {
  __typename?: 'ChatMessageConnection';
  edges: Array<ChatMessageEdge>;
  nodes: Array<ChatMessage>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ChatMessageEdge = {
  __typename?: 'ChatMessageEdge';
  cursor: Scalars['String']['output'];
  node: ChatMessage;
};

export type CheckUpdatesResponse = {
  __typename?: 'CheckUpdatesResponse';
  availableUpdate?: Maybe<AppVersion>;
  isUpdateRequired: Scalars['Boolean']['output'];
};

export type ClearPushTokenInput = {
  deviceId: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export enum ClientApp {
  Book = 'BOOK',
  Pal = 'PAL'
}

export type Comment = {
  __typename?: 'Comment';
  author: User;
  content: Scalars['String']['output'];
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  likes?: Maybe<Array<CommentLike>>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['Timestamp']['output'];
};

export type CommentLike = {
  __typename?: 'CommentLike';
  author: User;
  comment: Comment;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
};

export type CommentPostInput = {
  content: Scalars['String']['input'];
  postId: Scalars['ID']['input'];
};

export type CommentWithPost = {
  __typename?: 'CommentWithPost';
  author: User;
  content: Scalars['String']['output'];
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  likes?: Maybe<Array<CommentLike>>;
  post: Post;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['Timestamp']['output'];
};

export type CommunityGroup = {
  __typename?: 'CommunityGroup';
  admins: Array<User>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['Timestamp']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  joinInvitation: Array<JoinInvite>;
  joinRequests: Array<JoinRequest>;
  members: Array<User>;
  name: Scalars['String']['output'];
  owner: User;
  ownerId: Scalars['ID']['output'];
  posts?: Maybe<PostConnection>;
  public: Scalars['Boolean']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['Timestamp']['output'];
  uuid: Scalars['ID']['output'];
};


export type CommunityGroupJoinInvitationArgs = {
  fromId?: InputMaybe<Scalars['ID']['input']>;
};


export type CommunityGroupPostsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<PostFilterOptions>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PostOrderOptions>>;
};

export type Conversation = {
  __typename?: 'Conversation';
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  lastMessage?: Maybe<ChatMessage>;
  members: Array<ChatMember>;
  messages: ChatMessageConnection;
  name?: Maybe<Scalars['String']['output']>;
  owner: User;
  photo?: Maybe<File>;
  pinned: Scalars['Boolean']['output'];
  pinnedAt?: Maybe<Scalars['Timestamp']['output']>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['Timestamp']['output'];
  uuid: Scalars['ID']['output'];
};


export type ConversationMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateBookInput = {
  careReceiverId: Scalars['ID']['input'];
  pages: Array<NewPage>;
  title: Scalars['String']['input'];
};

export type CreateCommunityInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  privacy: PrivacySetting;
};

export type CreateFolderInput = {
  careReceiverId: Scalars['ID']['input'];
  iconUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateGroupInput = {
  membersIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  name: Scalars['String']['input'];
  photo?: InputMaybe<Scalars['Upload']['input']>;
};

export type CreateInformationFeedInput = {
  iconUrl?: InputMaybe<Scalars['String']['input']>;
  informationFolderId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type CreateInviteInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type CreateJoinInviteInput = {
  communityId: Scalars['ID']['input'];
  usersIds: Array<Scalars['ID']['input']>;
};

export type CreateJoinRequestInput = {
  communityId: Scalars['ID']['input'];
};

export type CreateOrganisationTeam = {
  name: Scalars['String']['input'];
  organisationUuid: Scalars['ID']['input'];
  parentTeamUuid?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePostInput = {
  communityGroupUuid?: InputMaybe<Scalars['ID']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  informationFeedId?: InputMaybe<Scalars['ID']['input']>;
  mediaFiles?: InputMaybe<Array<Scalars['Upload']['input']>>;
  organisationTeamsIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  organisationUuid?: InputMaybe<Scalars['ID']['input']>;
  publishAt?: InputMaybe<Scalars['Timestamp']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  selectedUsers?: InputMaybe<Array<Scalars['String']['input']>>;
  status: Scalars['String']['input'];
};

export type CreateProtegeInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type CreateRoomInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  participants: Array<Scalars['ID']['input']>;
};

export type CreateSubfolderInput = {
  iconUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parentFolderId: Scalars['ID']['input'];
};

export type CustomDatePeriod = {
  from: Scalars['Timestamp']['input'];
  to: Scalars['Timestamp']['input'];
};

export type Data = {
  __typename?: 'Data';
  author: User;
  content: Scalars['String']['output'];
  inviteId?: Maybe<Scalars['ID']['output']>;
  on?: Maybe<Post>;
  postId?: Maybe<Scalars['ID']['output']>;
  postUuid?: Maybe<Scalars['ID']['output']>;
  resourcePhoto?: Maybe<Scalars['String']['output']>;
};

export type DeleteBookInput = {
  id: Scalars['ID']['input'];
};

export type DeleteFolderInput = {
  id: Scalars['ID']['input'];
};

export type DeleteInformationFeedInput = {
  id: Scalars['ID']['input'];
};

export type DeleteOrganisationTeamInput = {
  teamUuid: Scalars['ID']['input'];
};

export type DeleteUser = {
  userId: Scalars['String']['input'];
};

export type DeviceInput = {
  appVersion?: InputMaybe<Scalars['String']['input']>;
  deviceId: Scalars['String']['input'];
  deviceName?: InputMaybe<Scalars['String']['input']>;
  expoPushToken?: InputMaybe<Scalars['String']['input']>;
  osName?: InputMaybe<Scalars['String']['input']>;
  osVersion?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<DeviceType>;
  webPushSubscription?: InputMaybe<WebPushSubscriptionInput>;
};

export enum DeviceType {
  Desktop = 'DESKTOP',
  Phone = 'PHONE',
  Tablet = 'TABLET',
  Tv = 'TV',
  Unknown = 'UNKNOWN'
}

export type File = {
  __typename?: 'File';
  blurhash?: Maybe<Scalars['String']['output']>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<User>;
  path: Scalars['String']['output'];
  thumbnailBlurhash?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  type: FileType;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['Timestamp']['output'];
  url: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

export type FileBase = {
  blurhash?: InputMaybe<Scalars['String']['input']>;
  path: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export enum FileType {
  Image = 'image',
  Other = 'other',
  Video = 'video'
}

export enum FriendshipRequestStatus {
  Accepted = 'ACCEPTED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type GetGroupInput = {
  groupId: Scalars['Int']['input'];
};

export type GetPostInput = {
  postId?: InputMaybe<Scalars['ID']['input']>;
  postUuid?: InputMaybe<Scalars['ID']['input']>;
};

export type GetSummaryInput = {
  fromDate: Scalars['Timestamp']['input'];
  toDate: Scalars['Timestamp']['input'];
  userId: Scalars['ID']['input'];
};

export type GetUserFriends = {
  userId?: InputMaybe<Scalars['ID']['input']>;
  userUuid?: InputMaybe<Scalars['String']['input']>;
};

export type Group = {
  __typename?: 'Group';
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  members: Array<User>;
  name: Scalars['String']['output'];
  owner: User;
  photo?: Maybe<File>;
  /** @deprecated Use photo.url */
  photoUrl?: Maybe<Scalars['String']['output']>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['Timestamp']['output'];
};

export type Icon = {
  __typename?: 'Icon';
  name: Scalars['String']['output'];
  tags?: Maybe<Array<Scalars['String']['output']>>;
  url: Scalars['String']['output'];
};

export enum InformationCollectionAccessType {
  OrganisationPublic = 'ORGANISATION_PUBLIC',
  Public = 'PUBLIC',
  SelectedUsers = 'SELECTED_USERS'
}

export type InformationFeed = {
  __typename?: 'InformationFeed';
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['Timestamp']['output'];
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  informationFolderId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  ownerId: Scalars['ID']['output'];
  posts: PostConnection;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['Timestamp']['output'];
};


export type InformationFeedPostsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<PostFilterOptions>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PostOrderOptions>>;
};

export type InformationFeedAccess = {
  __typename?: 'InformationFeedAccess';
  accessType: InformationCollectionAccessType;
  allowedOrganisationId?: Maybe<Scalars['ID']['output']>;
  allowedUserIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['Timestamp']['output'];
};

export type InformationFolder = {
  __typename?: 'InformationFolder';
  careReceiverId?: Maybe<Scalars['ID']['output']>;
  careReceiverProfileId?: Maybe<Scalars['ID']['output']>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['Timestamp']['output'];
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  informationFeeds: Array<InformationFeed>;
  name: Scalars['String']['output'];
  ownerId: Scalars['ID']['output'];
  parentFolderId?: Maybe<Scalars['ID']['output']>;
  subfolders: Array<InformationFolder>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['Timestamp']['output'];
};

export type InformationFolderAccess = {
  __typename?: 'InformationFolderAccess';
  accessType: InformationCollectionAccessType;
  allowedOrganisationId?: Maybe<Scalars['ID']['output']>;
  allowedUserIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['Timestamp']['output'];
};

export type Invite = {
  __typename?: 'Invite';
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['Timestamp']['output'];
  fromUser: User;
  id: Scalars['ID']['output'];
  status: FriendshipRequestStatus;
  toUser: User;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['Timestamp']['output'];
};

export type InviteInput = {
  id: Scalars['ID']['input'];
};

export type JoinInvite = {
  __typename?: 'JoinInvite';
  communityGroup: CommunityGroup;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['Timestamp']['output'];
  from: User;
  id: Scalars['ID']['output'];
  to: User;
  toUserId: Scalars['ID']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['Timestamp']['output'];
  uuid: Scalars['ID']['output'];
};

export type JoinRequest = {
  __typename?: 'JoinRequest';
  acceptedBy?: Maybe<User>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['Timestamp']['output'];
  from: User;
  id: Scalars['ID']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['Timestamp']['output'];
};

export type Keys = {
  __typename?: 'Keys';
  auth: Scalars['String']['output'];
  p256dh: Scalars['String']['output'];
};

export type Layer = {
  __typename?: 'Layer';
  height?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  image?: Maybe<File>;
  position?: Maybe<Position>;
  rotation?: Maybe<Scalars['Float']['output']>;
  scale?: Maybe<Scalars['Float']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  type: LayerType;
  url?: Maybe<Scalars['String']['output']>;
  video?: Maybe<File>;
  width?: Maybe<Scalars['Float']['output']>;
};

export enum LayerType {
  Audio = 'audio',
  Drawing = 'drawing',
  Image = 'image',
  Link = 'link',
  Shape = 'shape',
  Text = 'text',
  Video = 'video'
}

export type LeaveCommunityInput = {
  communityUuid: Scalars['ID']['input'];
};

export type LikeCommentInput = {
  commentId: Scalars['ID']['input'];
};

export type LikePostInput = {
  postId: Scalars['ID']['input'];
};

export type LoginInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
};

export type MemberOfOrganisation = {
  __typename?: 'MemberOfOrganisation';
  archivedAt?: Maybe<Scalars['Timestamp']['output']>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  organisation: Organisation;
  role: OrganisationRole;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['Timestamp']['output'];
};

export type MessageRead = {
  __typename?: 'MessageRead';
  member: MessageReader;
};

export type MessageReader = {
  __typename?: 'MessageReader';
  id: Scalars['ID']['output'];
  lastReadAt?: Maybe<Scalars['Timestamp']['output']>;
  lastReadMessageId?: Maybe<Scalars['ID']['output']>;
  memberId: Scalars['ID']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptAddToOrganisationRequest: Scalars['Boolean']['output'];
  acceptInvite: Scalars['Boolean']['output'];
  acceptJoinInvite?: Maybe<CommunityGroup>;
  acceptJoinRequest?: Maybe<JoinRequest>;
  acceptTermsOfUse: TermsOfUse;
  addCommunityAdmin: CommunityGroup;
  addMembersToTeam: OrganisationTeam;
  addTemporaryConnection: Scalars['Boolean']['output'];
  archiveChatRoom: Conversation;
  archiveOrganisationMember: OrganisationMemberUser;
  assignCareReceiverMemberToCaregiverMembers: OrganisationMemberUser;
  assignTeamsToMember: OrganisationMemberTeamsMembership;
  blockUser: User;
  changeCareRecipientPassword: User;
  changePassword: User;
  clearPushToken: Scalars['Boolean']['output'];
  commentPost: CommentWithPost;
  createBook: Book;
  createCareReceiverMember: OrganisationMemberUser;
  createCaregiverMember: OrganisationMemberUser;
  createChatRoom: Conversation;
  createCommunity?: Maybe<CommunityGroup>;
  createFriend: User;
  createGroup: Group;
  createInformationFeed: InformationFeed;
  createInformationFolder: InformationFolder;
  createInformationSubfolder: InformationFolder;
  createInvite: Invite;
  createPost: Post;
  createTeam: OrganisationTeam;
  createTermsOfUse: TermsOfUse;
  deleteBook: Book;
  deleteCommunity: CommunityGroup;
  deleteInformationFeed: Scalars['Boolean']['output'];
  deleteInformationFolder: Scalars['Boolean']['output'];
  deleteMessage: Scalars['Boolean']['output'];
  deleteTeam: Scalars['Boolean']['output'];
  deleteUser: User;
  disconnectCareGiver: Scalars['Boolean']['output'];
  inviteCaregivers: Scalars['Int']['output'];
  inviteSingleCaregiverForMultipleCareReceivers: Scalars['Int']['output'];
  leaveCommunity: CommunityGroup;
  likeComment: CommentLike;
  likePost: PostLike;
  login: Auth;
  markAllNotificationsRead: Scalars['Boolean']['output'];
  markConversationRead: Scalars['Boolean']['output'];
  pinChatRoom: Conversation;
  pinPost: Post;
  pingSummarize: Scalars['Boolean']['output'];
  refreshToken: Token;
  rejectAddToOrganisationRequest: Scalars['Boolean']['output'];
  rejectInvite: Invite;
  rejectJoinInvite: RejectJoinRequestPayload;
  rejectJoinRequest?: Maybe<JoinRequest>;
  removeAppInvitation: AppInvitation;
  removeComment: Scalars['Int']['output'];
  removeCommunityAdmin: CommunityGroup;
  removeCommunityMember: CommunityGroup;
  removeFile: Scalars['Boolean']['output'];
  removeFriend: Scalars['Boolean']['output'];
  removeGroup: Scalars['Int']['output'];
  removeGroupMember: Scalars['Int']['output'];
  removeInvite: Invite;
  removeLikeFromComment: CommentLike;
  removeLikeFromPost: PostLike;
  removeMemberFromTeam: Scalars['Int']['output'];
  removePost: Post;
  removeTemporaryConnection: Scalars['Boolean']['output'];
  reportMessage: ChatMessage;
  reportPost: Post;
  resendVerificationEmail: Scalars['Boolean']['output'];
  resetMemberPassword: Scalars['Boolean']['output'];
  resetPassword: Scalars['Boolean']['output'];
  restoreOrganisationMember: OrganisationMemberUser;
  reviewPost: Post;
  sendAddToOrganisationRequest: Scalars['Boolean']['output'];
  sendJoinInvite?: Maybe<Array<JoinInvite>>;
  sendJoinRequest?: Maybe<JoinRequest>;
  sendMessage: ChatMessage;
  /** Use only for first time password setting, it wont work if user has password already */
  setFirstPassword: Scalars['Boolean']['output'];
  setInformationFeedAccess: InformationFeedAccess;
  setInformationFolderAccess: InformationFolderAccess;
  setNewPassword: Scalars['Boolean']['output'];
  shareBookToCareGivers: Book;
  signup: Auth;
  unpinPost: Post;
  updateBook: Book;
  updateCareRecipientMember: OrganisationMemberUser;
  updateCaregiverMember: OrganisationMemberUser;
  updateChatRoom: Conversation;
  updateComment: Comment;
  updateCommunity?: Maybe<CommunityGroup>;
  updateGroup: Group;
  updateInformationFeed: InformationFeed;
  updateInformationFolder: InformationFolder;
  updateOrganisation: Organisation;
  updatePost: Post;
  updateTeam: OrganisationTeam;
  updateTeamMember: OrganisationTeamMember;
  updateUser: User;
  updateUserNames: User;
  updateUserPhone: User;
};


export type MutationAcceptAddToOrganisationRequestArgs = {
  requestId: Scalars['ID']['input'];
};


export type MutationAcceptInviteArgs = {
  data: InviteInput;
};


export type MutationAcceptJoinInviteArgs = {
  data: AcceptJoinRequestInput;
};


export type MutationAcceptJoinRequestArgs = {
  data: AcceptJoinRequestInput;
};


export type MutationAcceptTermsOfUseArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAddCommunityAdminArgs = {
  data: AddCommunityAdminInput;
};


export type MutationAddMembersToTeamArgs = {
  data: AddMembersToTeamInput;
};


export type MutationAddTemporaryConnectionArgs = {
  data: AddTemporaryConnectionInput;
};


export type MutationArchiveChatRoomArgs = {
  uuid: Scalars['ID']['input'];
};


export type MutationArchiveOrganisationMemberArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAssignCareReceiverMemberToCaregiverMembersArgs = {
  data: AssignCareReceiverMemberToCaregiverMembersInput;
};


export type MutationAssignTeamsToMemberArgs = {
  data: AssignTeamsToMemberInput;
};


export type MutationBlockUserArgs = {
  data: BlockUser;
};


export type MutationChangeCareRecipientPasswordArgs = {
  data: ChangeCareRecipientPasswordInput;
};


export type MutationChangePasswordArgs = {
  data: ChangePasswordInput;
};


export type MutationClearPushTokenArgs = {
  data: ClearPushTokenInput;
};


export type MutationCommentPostArgs = {
  data: CommentPostInput;
};


export type MutationCreateBookArgs = {
  data: CreateBookInput;
};


export type MutationCreateCareReceiverMemberArgs = {
  data: CareReceiverMemberInput;
  organisationUuid: Scalars['String']['input'];
};


export type MutationCreateCaregiverMemberArgs = {
  data: CaregiverMemberInput;
  organisationUuid: Scalars['String']['input'];
};


export type MutationCreateChatRoomArgs = {
  data: CreateRoomInput;
};


export type MutationCreateCommunityArgs = {
  data: CreateCommunityInput;
};


export type MutationCreateFriendArgs = {
  data: CreateProtegeInput;
};


export type MutationCreateGroupArgs = {
  data: CreateGroupInput;
};


export type MutationCreateInformationFeedArgs = {
  data: CreateInformationFeedInput;
};


export type MutationCreateInformationFolderArgs = {
  data: CreateFolderInput;
};


export type MutationCreateInformationSubfolderArgs = {
  data: CreateSubfolderInput;
};


export type MutationCreateInviteArgs = {
  data: CreateInviteInput;
};


export type MutationCreatePostArgs = {
  data: CreatePostInput;
};


export type MutationCreateTeamArgs = {
  data: CreateOrganisationTeam;
};


export type MutationCreateTermsOfUseArgs = {
  organisationUuid: Scalars['String']['input'];
  text: Scalars['String']['input'];
};


export type MutationDeleteBookArgs = {
  data: DeleteBookInput;
};


export type MutationDeleteCommunityArgs = {
  data: LeaveCommunityInput;
};


export type MutationDeleteInformationFeedArgs = {
  data: DeleteInformationFeedInput;
};


export type MutationDeleteInformationFolderArgs = {
  data: DeleteFolderInput;
};


export type MutationDeleteMessageArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTeamArgs = {
  data: DeleteOrganisationTeamInput;
};


export type MutationDeleteUserArgs = {
  data: DeleteUser;
};


export type MutationDisconnectCareGiverArgs = {
  careGiverUuid: Scalars['String']['input'];
  careReceiverUuid: Scalars['String']['input'];
};


export type MutationInviteCaregiversArgs = {
  careReceiverUuid: Scalars['String']['input'];
  emails: Array<Scalars['String']['input']>;
};


export type MutationInviteSingleCaregiverForMultipleCareReceiversArgs = {
  careReceiverUuids: Array<Scalars['String']['input']>;
  caregiverUuid: Scalars['String']['input'];
};


export type MutationLeaveCommunityArgs = {
  data: LeaveCommunityInput;
};


export type MutationLikeCommentArgs = {
  data: LikeCommentInput;
};


export type MutationLikePostArgs = {
  data: LikePostInput;
};


export type MutationLoginArgs = {
  data: LoginInput;
};


export type MutationMarkConversationReadArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPinChatRoomArgs = {
  data: PinChatRoomInput;
};


export type MutationPinPostArgs = {
  data: LikePostInput;
};


export type MutationRefreshTokenArgs = {
  data: RefreshTokenInput;
};


export type MutationRejectAddToOrganisationRequestArgs = {
  requestId: Scalars['ID']['input'];
};


export type MutationRejectInviteArgs = {
  data: InviteInput;
};


export type MutationRejectJoinInviteArgs = {
  data: AcceptJoinRequestInput;
};


export type MutationRejectJoinRequestArgs = {
  data: RejectJoinRequestInput;
};


export type MutationRemoveAppInvitationArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveCommentArgs = {
  data: RemoveCommentInput;
};


export type MutationRemoveCommunityAdminArgs = {
  data: RemoveCommunityAdminInput;
};


export type MutationRemoveCommunityMemberArgs = {
  data: RemoveCommunityMemberInput;
};


export type MutationRemoveFileArgs = {
  data: RemoveFileInput;
};


export type MutationRemoveFriendArgs = {
  uuid: Scalars['String']['input'];
};


export type MutationRemoveGroupArgs = {
  data: GetGroupInput;
};


export type MutationRemoveGroupMemberArgs = {
  data: RemoveGroupMemberInput;
};


export type MutationRemoveInviteArgs = {
  data: InviteInput;
};


export type MutationRemoveLikeFromCommentArgs = {
  data: RemoveLikeFromCommentInput;
};


export type MutationRemoveLikeFromPostArgs = {
  data: RemoveLikeFromPostInput;
};


export type MutationRemoveMemberFromTeamArgs = {
  data: RemoveMemberFromTeamInput;
};


export type MutationRemovePostArgs = {
  data: LikePostInput;
};


export type MutationRemoveTemporaryConnectionArgs = {
  uuid: Scalars['ID']['input'];
};


export type MutationReportMessageArgs = {
  id: Scalars['ID']['input'];
};


export type MutationReportPostArgs = {
  data: LikePostInput;
};


export type MutationResetMemberPasswordArgs = {
  id: Scalars['ID']['input'];
  newPassword?: InputMaybe<Scalars['String']['input']>;
};


export type MutationResetPasswordArgs = {
  data: ResetPasswordInput;
};


export type MutationRestoreOrganisationMemberArgs = {
  id: Scalars['ID']['input'];
};


export type MutationReviewPostArgs = {
  data: PostReviewInput;
};


export type MutationSendAddToOrganisationRequestArgs = {
  organisationUuid: Scalars['ID']['input'];
  toUsername: Scalars['String']['input'];
};


export type MutationSendJoinInviteArgs = {
  data: CreateJoinInviteInput;
};


export type MutationSendJoinRequestArgs = {
  data: CreateJoinRequestInput;
};


export type MutationSendMessageArgs = {
  data: SendMessageInput;
};


export type MutationSetFirstPasswordArgs = {
  data: SetNewPasswordInput;
};


export type MutationSetInformationFeedAccessArgs = {
  data: SetInformationFeedAccessInput;
};


export type MutationSetInformationFolderAccessArgs = {
  data: SetInformationFolderAccessInput;
};


export type MutationSetNewPasswordArgs = {
  data: SetNewPasswordInput;
};


export type MutationShareBookToCareGiversArgs = {
  data: ShareBookInput;
};


export type MutationSignupArgs = {
  data: SignupInput;
};


export type MutationUnpinPostArgs = {
  data: LikePostInput;
};


export type MutationUpdateBookArgs = {
  data: UpdateBookInput;
};


export type MutationUpdateCareRecipientMemberArgs = {
  data: UpdateCareRecipientMemberInput;
};


export type MutationUpdateCaregiverMemberArgs = {
  data: UpdateCaregiverMemberInput;
};


export type MutationUpdateChatRoomArgs = {
  data: UpdateChatRoomInput;
};


export type MutationUpdateCommentArgs = {
  data: UpdateCommentInput;
};


export type MutationUpdateCommunityArgs = {
  data: UpdateCommunityInput;
};


export type MutationUpdateGroupArgs = {
  data: UpdateGroupInput;
};


export type MutationUpdateInformationFeedArgs = {
  data: UpdateInformationFeedInput;
};


export type MutationUpdateInformationFolderArgs = {
  data: UpdateFolderInput;
};


export type MutationUpdateOrganisationArgs = {
  data: UpdateOrganisationInput;
};


export type MutationUpdatePostArgs = {
  data: UpdatePostInput;
};


export type MutationUpdateTeamArgs = {
  data: UpdateOrganisationTeamInput;
};


export type MutationUpdateTeamMemberArgs = {
  data: UpdateOrganisationTeamMemberInput;
};


export type MutationUpdateUserArgs = {
  data: UpdateUser;
};


export type MutationUpdateUserNamesArgs = {
  data: UpdateUserNames;
};


export type MutationUpdateUserPhoneArgs = {
  data: UpdateUserPhone;
};

export type NewChatMessageEdge = {
  __typename?: 'NewChatMessageEdge';
  cursor: Scalars['String']['output'];
  node: ChatMessage;
};

export type NewLayer = {
  height?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['String']['input'];
  image?: InputMaybe<FileBase>;
  newImage?: InputMaybe<Scalars['Upload']['input']>;
  newVideo?: InputMaybe<Scalars['Upload']['input']>;
  position?: InputMaybe<PositionInput>;
  rotation?: InputMaybe<Scalars['Float']['input']>;
  scale?: InputMaybe<Scalars['Float']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  type: LayerType;
  url?: InputMaybe<Scalars['String']['input']>;
  video?: InputMaybe<FileBase>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type NewMemberInOrganisation = {
  __typename?: 'NewMemberInOrganisation';
  member: OrganisationMemberUser;
};

export type NewMemberInOrganisationInput = {
  uuid: Scalars['String']['input'];
};

export type NewMessage = {
  __typename?: 'NewMessage';
  content: Scalars['String']['output'];
  conversationId: Scalars['ID']['output'];
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['Timestamp']['output'];
  from: User;
  id: Scalars['ID']['output'];
  media: Array<File>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['Timestamp']['output'];
};

export type NewMessageInConversationInput = {
  id: Scalars['ID']['input'];
};

export type NewNotification = {
  __typename?: 'NewNotification';
  text: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export type NewPage = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  layers: Array<NewLayer>;
};

export type NewPostEdge = {
  __typename?: 'NewPostEdge';
  cursor: Scalars['String']['output'];
  node: Post;
};

export type NewPostInCareReceiverFeedInput = {
  uuid: Array<Scalars['ID']['input']>;
};

export type NewPostInCommunityInput = {
  uuid: Scalars['ID']['input'];
};

export type NewPostInInformationInput = {
  id: Scalars['ID']['input'];
};

export type Notification = {
  __typename?: 'Notification';
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['Timestamp']['output'];
  data: Data;
  id: Scalars['ID']['output'];
  readAt?: Maybe<Scalars['Timestamp']['output']>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['Timestamp']['output'];
  user: User;
};

export type NotificationConnection = {
  __typename?: 'NotificationConnection';
  edges: Array<NotificationEdge>;
  nodes: Array<Notification>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NotificationEdge = {
  __typename?: 'NotificationEdge';
  cursor: Scalars['String']['output'];
  node: Notification;
};

export enum OrderDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Organisation = {
  __typename?: 'Organisation';
  allTermsOfUse: Array<TermsOfUse>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  members: Array<OrganisationMemberUser>;
  name: Scalars['String']['output'];
  teams: Array<OrganisationTeam>;
  temporaryAccesses: OrganisationTemporaryAccesses;
  termsOfUse?: Maybe<TermsOfUse>;
  termsOfUseTemplate: Scalars['String']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['Timestamp']['output'];
  uuid: Scalars['ID']['output'];
};

export type OrganisationImportMemberRequest = {
  __typename?: 'OrganisationImportMemberRequest';
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['Timestamp']['output'];
  fromOrganisationMember: OrganisationMemberUser;
  id: Scalars['ID']['output'];
  organisation: Organisation;
  status: FriendshipRequestStatus;
  toUser: User;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['Timestamp']['output'];
};

export type OrganisationInfo = {
  __typename?: 'OrganisationInfo';
  name: Scalars['String']['output'];
  role: OrganisationRole;
  teams: Array<TeamInfo>;
  type?: Maybe<OrganisationType>;
  uuid: Scalars['ID']['output'];
};

export type OrganisationMemberTeamsMembership = {
  __typename?: 'OrganisationMemberTeamsMembership';
  archivedAt?: Maybe<Scalars['Timestamp']['output']>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  role: OrganisationRole;
  teamsMembership: Array<OrganisationTeamMember>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['Timestamp']['output'];
};

export type OrganisationMemberUser = {
  __typename?: 'OrganisationMemberUser';
  acceptedTerms?: Maybe<TermsOfUse>;
  acceptedTermsAt?: Maybe<Scalars['Timestamp']['output']>;
  archivedAt?: Maybe<Scalars['Timestamp']['output']>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  role: OrganisationRole;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['Timestamp']['output'];
  user: User;
};

export enum OrganisationRole {
  Admin = 'ADMIN',
  Manager = 'MANAGER',
  Member = 'MEMBER'
}

export type OrganisationTeam = {
  __typename?: 'OrganisationTeam';
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  members: Array<OrganisationTeamMember>;
  name: Scalars['String']['output'];
  organisation: Organisation;
  parentTeam?: Maybe<OrganisationTeam>;
  postsScreeningEnabled: Scalars['Boolean']['output'];
  subTeams: Array<OrganisationTeam>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['Timestamp']['output'];
  uuid: Scalars['ID']['output'];
};

export type OrganisationTeamMember = {
  __typename?: 'OrganisationTeamMember';
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  organisationMember: OrganisationMemberUser;
  role: OrganisationTeamRole;
  team: OrganisationMemberUser;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['Timestamp']['output'];
};

export enum OrganisationTeamRole {
  Admin = 'ADMIN',
  Member = 'MEMBER'
}

export type OrganisationTemporaryAccesses = {
  __typename?: 'OrganisationTemporaryAccesses';
  appInvitations: Array<AppInvitation>;
  connections: Array<TemporaryConnection>;
};

export enum OrganisationType {
  Bpa = 'Bpa',
  Education = 'Education',
  Idd = 'Idd',
  Senior = 'Senior'
}

export type Page = {
  __typename?: 'Page';
  backgroundColor?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  layers: Array<Layer>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PinChatRoomInput = {
  pin: Scalars['Boolean']['input'];
  roomId: Scalars['ID']['input'];
};

export type Position = {
  __typename?: 'Position';
  left: Scalars['Float']['output'];
  top: Scalars['Float']['output'];
};

export type PositionInput = {
  left: Scalars['Float']['input'];
  top: Scalars['Float']['input'];
};

export type Post = {
  __typename?: 'Post';
  author?: Maybe<User>;
  authorId?: Maybe<Scalars['Int']['output']>;
  comments: Array<Comment>;
  communityGroupId?: Maybe<Scalars['ID']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['Timestamp']['output'];
  hasPublicationError: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  informationFeedId?: Maybe<Scalars['ID']['output']>;
  likes?: Maybe<Array<PostLike>>;
  media?: Maybe<Scalars['String']['output']>;
  mediaFiles: Array<File>;
  pinned: Scalars['Boolean']['output'];
  publishAt?: Maybe<Scalars['Timestamp']['output']>;
  /** @deprecated Not supported */
  published?: Maybe<Scalars['Boolean']['output']>;
  publishedAt?: Maybe<Scalars['Timestamp']['output']>;
  review?: Maybe<PostReview>;
  selectedUsers?: Maybe<Array<PostAccess>>;
  status: Scalars['String']['output'];
  type: PostType;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['Timestamp']['output'];
  uuid: Scalars['ID']['output'];
  viewCount: Scalars['Int']['output'];
};

export type PostAccess = {
  __typename?: 'PostAccess';
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  post: Post;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['Timestamp']['output'];
  user: User;
};

export type PostConnection = {
  __typename?: 'PostConnection';
  edges: Array<PostEdge>;
  nodes: Array<Post>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PostEdge = {
  __typename?: 'PostEdge';
  cursor: Scalars['String']['output'];
  node: Post;
};

export type PostFilterOptions = {
  careRecipients?: InputMaybe<Array<Scalars['ID']['input']>>;
  publishedInCustomPeriod?: InputMaybe<CustomDatePeriod>;
  publishedInLastDays?: InputMaybe<Scalars['Float']['input']>;
  userTags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PostLike = {
  __typename?: 'PostLike';
  author: User;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  post: Post;
};

export enum PostOrderByFields {
  CreatedAt = 'createdAt',
  Id = 'id',
  Pinned = 'pinned',
  PublishedAt = 'publishedAt'
}

export type PostOrderOptions = {
  direction: OrderDirection;
  field: PostOrderByFields;
};

export type PostReview = {
  __typename?: 'PostReview';
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['Timestamp']['output'];
  feedback?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  post: Post;
  reviewer?: Maybe<BasicUser>;
  status: PostReviewStatus;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['Timestamp']['output'];
  uuid: Scalars['ID']['output'];
};

export type PostReviewInput = {
  feedback?: InputMaybe<Scalars['String']['input']>;
  postId: Scalars['Int']['input'];
  status: PostReviewStatus;
};

export enum PostReviewStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export enum PostType {
  Book = 'BOOK',
  Feed = 'FEED',
  Information = 'INFORMATION',
  Organisation = 'ORGANISATION'
}

export type PostUpdated = {
  __typename?: 'PostUpdated';
  newComment?: Maybe<Comment>;
  newLike?: Maybe<PostLike>;
  post?: Maybe<NewPostEdge>;
  removedComment?: Maybe<Comment>;
  removedLike?: Maybe<PostLike>;
};

export type PostUpdatedInput = {
  uuid: Array<Scalars['ID']['input']>;
};

export enum PrivacySetting {
  Private = 'private',
  Public = 'public'
}

export type Profile = {
  __typename?: 'Profile';
  criticalInfo: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  informationFolders?: Maybe<Array<InformationFolder>>;
  negativeInfo: Array<Scalars['String']['output']>;
  positiveInfo: Array<Scalars['String']['output']>;
};

export type ProtegesListUpdatedPayload = {
  __typename?: 'ProtegesListUpdatedPayload';
  added?: Maybe<User>;
  removedUuid?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  availableTagNames: Array<Scalars['String']['output']>;
  book: Book;
  careRecipientsAvailableToInviteForCaregiver: Array<User>;
  checkUpdates: CheckUpdatesResponse;
  conversation?: Maybe<Conversation>;
  currentUser: User;
  getGroup: Group;
  group?: Maybe<CommunityGroup>;
  icons: Array<Icon>;
  informationFeed: InformationFeed;
  informationFeedAccess: InformationFeedAccess;
  informationFolder: InformationFolder;
  informationFolderAccess: InformationFolderAccess;
  invitationsFromFamilyCaregivers: Array<Invite>;
  organisation: Organisation;
  organisationMember: OrganisationMemberUser;
  post: Post;
  postsSubmittedForReview: Array<Post>;
  postsToReview: Array<Post>;
  publicGroups: Array<CommunityGroup>;
  scheduledPosts: Array<ScheduledPost>;
  searchUsers: Array<User>;
  summarizePosts: Summary;
  user: User;
};


export type QueryBookArgs = {
  data: DeleteBookInput;
};


export type QueryCareRecipientsAvailableToInviteForCaregiverArgs = {
  caregiverUuid: Scalars['String']['input'];
};


export type QueryCheckUpdatesArgs = {
  androidVersionCode?: InputMaybe<Scalars['Int']['input']>;
  app: ClientApp;
  iOSBuildNumber?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryConversationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetGroupArgs = {
  data: GetGroupInput;
};


export type QueryGroupArgs = {
  uuid: Scalars['ID']['input'];
};


export type QueryInformationFeedArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInformationFeedAccessArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInformationFolderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInformationFolderAccessArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInvitationsFromFamilyCaregiversArgs = {
  organisationUuid: Scalars['String']['input'];
};


export type QueryOrganisationArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryOrganisationMemberArgs = {
  id: Scalars['String']['input'];
};


export type QueryPostArgs = {
  data: GetPostInput;
};


export type QuerySearchUsersArgs = {
  data: SearchUserFriends;
};


export type QuerySummarizePostsArgs = {
  data: GetSummaryInput;
};


export type QueryUserArgs = {
  data: GetUserFriends;
};

export type RefreshTokenInput = {
  refreshToken: Scalars['String']['input'];
};

export type RejectJoinRequestInput = {
  id: Scalars['ID']['input'];
};

export type RejectJoinRequestPayload = {
  __typename?: 'RejectJoinRequestPayload';
  communityGroupId: Scalars['ID']['output'];
};

export type RemoveCommentInput = {
  id: Scalars['Int']['input'];
};

export type RemoveCommunityAdminInput = {
  adminUuid: Scalars['ID']['input'];
  communityUuid: Scalars['ID']['input'];
};

export type RemoveCommunityMemberInput = {
  communityUuid: Scalars['ID']['input'];
  memberId: Scalars['ID']['input'];
};

export type RemoveFileInput = {
  uuid: Scalars['ID']['input'];
};

export type RemoveGroupMemberInput = {
  groupId: Scalars['Int']['input'];
  memberId: Scalars['Int']['input'];
};

export type RemoveLikeFromCommentInput = {
  likeId: Scalars['ID']['input'];
};

export type RemoveLikeFromPostInput = {
  likeId: Scalars['ID']['input'];
};

export type RemoveMemberFromTeamInput = {
  memberId: Scalars['ID']['input'];
  teamUuid: Scalars['ID']['input'];
};

export type ResetPasswordInput = {
  email: Scalars['String']['input'];
};

export type ScheduledPost = {
  __typename?: 'ScheduledPost';
  content?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  mediaFiles: Array<File>;
  publishAt: Scalars['Timestamp']['output'];
  uuid: Scalars['ID']['output'];
};

export type SearchUserFriends = {
  restricted?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<UserRole>;
  search: Scalars['String']['input'];
};

export type SendMessageInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<Array<Scalars['Upload']['input']>>;
  roomId: Scalars['ID']['input'];
};

export type SetInformationFeedAccessInput = {
  allowedOrganisationId?: InputMaybe<Scalars['ID']['input']>;
  allowedUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  id: Scalars['ID']['input'];
  type: InformationCollectionAccessType;
};

export type SetInformationFolderAccessInput = {
  allowedOrganisationId?: InputMaybe<Scalars['ID']['input']>;
  allowedUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  id: Scalars['ID']['input'];
  type: InformationCollectionAccessType;
};

export type SetNewPasswordInput = {
  code: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};

export type ShareBookInput = {
  id: Scalars['ID']['input'];
};

export type SignupInput = {
  email: Scalars['String']['input'];
  newsletter?: InputMaybe<Scalars['Boolean']['input']>;
  password: Scalars['String']['input'];
  registerCode?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
};

export type Subscription = {
  __typename?: 'Subscription';
  inviteAdded?: Maybe<Invite>;
  newMemberInOrganisation: NewMemberInOrganisation;
  newMessage?: Maybe<NewMessage>;
  newMessageInConversation?: Maybe<NewChatMessageEdge>;
  newMessageReadInConversation: MessageRead;
  newPostInCareReceiverFeed?: Maybe<NewPostEdge>;
  newPostInCommunity?: Maybe<NewPostEdge>;
  newPostInInformation?: Maybe<NewPostEdge>;
  notificationAdded?: Maybe<NewNotification>;
  postUpdated?: Maybe<PostUpdated>;
  protegesListUpdated: ProtegesListUpdatedPayload;
};


export type SubscriptionInviteAddedArgs = {
  userId: Scalars['String']['input'];
};


export type SubscriptionNewMemberInOrganisationArgs = {
  input: NewMemberInOrganisationInput;
};


export type SubscriptionNewMessageArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionNewMessageInConversationArgs = {
  input: NewMessageInConversationInput;
};


export type SubscriptionNewMessageReadInConversationArgs = {
  input: NewMessageInConversationInput;
};


export type SubscriptionNewPostInCareReceiverFeedArgs = {
  input: NewPostInCareReceiverFeedInput;
};


export type SubscriptionNewPostInCommunityArgs = {
  input: NewPostInCommunityInput;
};


export type SubscriptionNewPostInInformationArgs = {
  input: NewPostInInformationInput;
};


export type SubscriptionNotificationAddedArgs = {
  userId: Scalars['String']['input'];
};


export type SubscriptionPostUpdatedArgs = {
  input: PostUpdatedInput;
};

export enum SubscriptionType {
  Business = 'business',
  Freemium = 'freemium',
  Premium = 'premium'
}

export type Summary = {
  __typename?: 'Summary';
  for: BasicUser;
  fromPostIds: Array<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  keyInsights: Array<Scalars['String']['output']>;
  mediaFiles: Array<File>;
  mood: Scalars['String']['output'];
  suggestions: Array<Scalars['String']['output']>;
  text: Scalars['String']['output'];
};

export type TeamInfo = {
  __typename?: 'TeamInfo';
  members: Array<OrganisationTeamMember>;
  name: Scalars['String']['output'];
  postsScreeningEnabled: Scalars['Boolean']['output'];
  role: OrganisationTeamRole;
  uuid: Scalars['ID']['output'];
};

export type TemporaryConnection = {
  __typename?: 'TemporaryConnection';
  careRecipient: User;
  caregiver: User;
  endDate: Scalars['Timestamp']['output'];
  uuid: Scalars['ID']['output'];
};

export type TermsOfUse = {
  __typename?: 'TermsOfUse';
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  membersAccepted: Array<OrganisationMemberUser>;
  text: Scalars['String']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['Timestamp']['output'];
  uuid: Scalars['ID']['output'];
};

export type Token = {
  __typename?: 'Token';
  /** JWT access token */
  accessToken: Scalars['String']['output'];
  /** JWT media access token */
  mediaToken: Scalars['String']['output'];
  /** JWT refresh token */
  refreshToken: Scalars['String']['output'];
};

export type UpdateBookInput = {
  data: UpdateDataBookInput;
  id: Scalars['ID']['input'];
};

export type UpdateCareRecipientMemberInput = {
  blockLogin?: InputMaybe<Scalars['Boolean']['input']>;
  criticalInfo?: InputMaybe<Array<Scalars['String']['input']>>;
  device?: InputMaybe<DeviceInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  info?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaFile?: InputMaybe<Scalars['Upload']['input']>;
  memberId: Scalars['ID']['input'];
  negativeInfo?: InputMaybe<Array<Scalars['String']['input']>>;
  organisationUuid: Scalars['ID']['input'];
  positiveInfo?: InputMaybe<Array<Scalars['String']['input']>>;
  pushToken?: InputMaybe<Scalars['String']['input']>;
  receiveSummaryNotificationEmails?: InputMaybe<Scalars['Boolean']['input']>;
  restrictedAccess?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<UserVisibility>;
};

export type UpdateCaregiverMemberInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<OrganisationRole>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateChatRoomInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  participantsIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  photo?: InputMaybe<Scalars['Upload']['input']>;
  roomId: Scalars['ID']['input'];
};

export type UpdateCommentInput = {
  content: Scalars['String']['input'];
  id: Scalars['Int']['input'];
};

export type UpdateCommunityInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  privacy?: InputMaybe<PrivacySetting>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateDataBookInput = {
  pages: Array<NewPage>;
  title: Scalars['String']['input'];
};

export type UpdateFolderInput = {
  iconUrl?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateGroupInput = {
  id: Scalars['Int']['input'];
  membersIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['Upload']['input']>;
};

export type UpdateInformationFeedInput = {
  iconUrl?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrganisationInput = {
  name: Scalars['String']['input'];
  uuid: Scalars['ID']['input'];
};

export type UpdateOrganisationTeamInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  postsScreeningEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  teamUuid: Scalars['ID']['input'];
};

export type UpdateOrganisationTeamMemberInput = {
  memberId: Scalars['String']['input'];
  role: OrganisationTeamRole;
  teamUuid: Scalars['ID']['input'];
};

export type UpdatePostInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  newMediaFiles?: InputMaybe<Array<Scalars['Upload']['input']>>;
  publishAt?: InputMaybe<Scalars['Timestamp']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  selectedExistingMedia?: InputMaybe<Array<Scalars['ID']['input']>>;
  selectedUsers?: InputMaybe<Array<Scalars['String']['input']>>;
  status: Scalars['String']['input'];
};

export type UpdateUser = {
  criticalInfo?: InputMaybe<Array<Scalars['String']['input']>>;
  device?: InputMaybe<DeviceInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  info?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mediaFile?: InputMaybe<Scalars['Upload']['input']>;
  negativeInfo?: InputMaybe<Array<Scalars['String']['input']>>;
  positiveInfo?: InputMaybe<Array<Scalars['String']['input']>>;
  pushToken?: InputMaybe<Scalars['String']['input']>;
  receiveSummaryNotificationEmails?: InputMaybe<Scalars['Boolean']['input']>;
  restrictedAccess?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<UserVisibility>;
};

export type UpdateUserNames = {
  firstName: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  lastName: Scalars['String']['input'];
};

export type UpdateUserPhone = {
  id: Scalars['ID']['input'];
  telephone: Scalars['String']['input'];
};

export type User = {
  __typename?: 'User';
  addToOrganisationRequestsReceived: Array<OrganisationImportMemberRequest>;
  adminOfCommunityGroups: Array<CommunityGroup>;
  appInvitationsToConnect: Array<AppInvitation>;
  books: Array<Book>;
  /** Merged list of temporary and permanent care recipients */
  caregiverOf: Array<User>;
  /** Merged list of temporary and permanent caregivers */
  caregivers: Array<User>;
  communityInvites: Array<JoinInvite>;
  conversations: Array<Conversation>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['Timestamp']['output'];
  email?: Maybe<Scalars['String']['output']>;
  emailVerified: Scalars['Boolean']['output'];
  files: Array<File>;
  firstName?: Maybe<Scalars['String']['output']>;
  friendshipRequestsReceived: Array<Invite>;
  friendshipRequestsSent: Array<Invite>;
  guardianOf?: Maybe<Array<User>>;
  guardians: Array<User>;
  hasCreatedPosts: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  info?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  memberOfCommunityGroups: Array<CommunityGroup>;
  memberOfGroups: Array<Group>;
  notifications: NotificationConnection;
  organisationInfo?: Maybe<OrganisationInfo>;
  organisationMember?: Maybe<Array<MemberOfOrganisation>>;
  ownedGroups: Array<Group>;
  /** @deprecated Use profilePhoto.url */
  photoUrl?: Maybe<Scalars['String']['output']>;
  posts?: Maybe<PostConnection>;
  profile?: Maybe<Profile>;
  profilePhoto?: Maybe<File>;
  proteges: Array<User>;
  receiveSummaryNotificationEmails?: Maybe<Scalars['Boolean']['output']>;
  restrictedAccess?: Maybe<Scalars['Boolean']['output']>;
  role: Scalars['String']['output'];
  sentAppInvitations: Array<AppInvitation>;
  sentCommunityInvites: Array<JoinInvite>;
  subscriptionType: SubscriptionType;
  superPalOf: Array<User>;
  superPals: Array<User>;
  tags: Array<Scalars['String']['output']>;
  telephone?: Maybe<Scalars['String']['output']>;
  temporaryCaregiverOf: Array<UserTemporaryConnection>;
  temporaryCaregivers: Array<UserTemporaryConnection>;
  unreadConversationIds: Array<Scalars['Float']['output']>;
  unreadNotificationsCount: Scalars['Int']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['Timestamp']['output'];
  uploadedFiles: Array<UserUploadedFile>;
  username: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
  visibility: UserVisibility;
};


export type UserConversationsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type UserNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserPostsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<PostFilterOptions>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PostOrderOptions>>;
};

export enum UserRole {
  OrganisationAdmin = 'ORGANISATION_ADMIN',
  Pal = 'PAL',
  User = 'USER'
}

export type UserTemporaryConnection = {
  __typename?: 'UserTemporaryConnection';
  endDate: Scalars['Timestamp']['output'];
  user: User;
};

export type UserUploadedFile = {
  __typename?: 'UserUploadedFile';
  blurhash?: Maybe<Scalars['String']['output']>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<User>;
  path: Scalars['String']['output'];
  posts: BasePost;
  thumbnailBlurhash?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  type: FileType;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['Timestamp']['output'];
  url: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

export enum UserVisibility {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type WebPushSubscription = {
  __typename?: 'WebPushSubscription';
  endpoint: Scalars['String']['output'];
  expirationTime?: Maybe<Scalars['Timestamp']['output']>;
  keys: Keys;
};

export type WebPushSubscriptionInput = {
  endpoint: Scalars['String']['input'];
  expirationTime?: InputMaybe<Scalars['Timestamp']['input']>;
  keys: WebPushSubscriptionKeysInput;
};

export type WebPushSubscriptionKeysInput = {
  auth: Scalars['String']['input'];
  p256dh: Scalars['String']['input'];
};
